module.exports = __webpack_public_path__ + "static/media/close.1b286ef8.svg";